var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, IconAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { DivLongText, DivStatus } from "../assets/style";
export var filtersData = function (Filters) {
    return [
        {
            name: "Producto",
            type: "label",
            label: Filters.Product,
        },
        {
            name: "Plan",
            type: "label",
            label: Filters.Plan,
        },
        {
            name: "Tipo de pago",
            type: "label",
            label: Filters.Payment,
        },
        {
            name: "Tipo de cobertura",
            type: "label",
            label: Filters.CoverType,
        },
        {
            name: "Campaña",
            type: "label",
            label: Filters.Campaign,
        },
        {
            name: "Prima",
            type: "label",
            label: Filters.Price,
        },
        {
            name: "Año",
            label: Filters.year,
            type: "label",
        },
        {
            name: "Modelo",
            label: Filters.model,
            type: "label",
        },
        {
            name: "Marca",
            label: Filters.brand,
            type: "label",
        },
        {
            name: "Chasis",
            label: Filters.chassis,
            type: "label",
        },
        {
            name: "Placa",
            label: Filters.plate,
            type: "label",
        },
        {
            name: "Estado del Vehiculo",
            label: Filters.statusVehicle,
            type: "label",
        },
    ];
};
var getStatusColor = function (state) {
    switch (state) {
        case "Aprobado":
            return "green";
        case "Rechazado":
            return "red";
        case "Pendiente":
            return "yellow";
        case "Sin documento":
            return "blue";
        default:
            return "gray";
    }
};
export var ColumnsGrid = function (handleClickContextMenu, disableUpload, disableView) { return [
    {
        editable: false,
        field: "actions",
        headerName: "Acciones",
        width: 125,
        renderCell: function (param) {
            var isSinDocument = param.row.state === "Sin documento";
            return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: !disableUpload,
                            icon: {
                                color: "#006ac6",
                                icon: icons.UploadFile,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Subir documento",
                        },
                        {
                            disabled: isSinDocument || !disableView,
                            icon: {
                                color: "#006ac6",
                                icon: icons.Visibility,
                                size: sizesIcon.standard,
                            },
                            id: "2",
                            name: "Visualizar",
                        },
                        // {
                        //   disabled: isSinDocument,
                        //   icon: {
                        //     color: "#006ac6",
                        //     icon: icons.HistoryEdu,
                        //     size: sizesIcon.standard,
                        //   },
                        //   id: "3",
                        //   name: "Ver historial",
                        // },
                    ], onClickContextMenu: function (item) { return handleClickContextMenu(item, param); }, sizeIcon: sizesIcon.standard }) })));
        },
    },
    {
        editable: false,
        field: "docType",
        headerName: "Tipo de documento",
        width: 250,
        renderCell: function (params) {
            return _jsx(DivLongText, { children: params.value });
        },
    },
    {
        editable: false,
        field: "state",
        headerName: "Estado",
        renderCell: function (params) {
            return (_jsxs(DivStatus, { children: [_jsx(IconAFY, { icon: icons.Circle, color: getStatusColor(params.value) }), " ", params.value] }));
        },
        width: 150,
    },
    {
        editable: false,
        field: "date",
        headerName: "Fecha",
        width: 125,
    },
    {
        editable: false,
        field: "user",
        headerName: "Usuario",
        width: 125,
    },
    {
        field: "comments",
        flex: 1,
        headerName: "Comentarios",
        renderCell: function (params) {
            return _jsx(DivLongText, { children: params.value });
        },
    },
]; };
export var DataForm = {
    brand: "",
    model: "",
    carColor: "",
    chassisNumber: "",
    carPrice: "",
    numberCylinders: "",
    fuelType: "",
    registrationNumber: "",
    DocumentNumber: "",
    QuoteNumber: "",
    QuoteStatusName: "",
    QuoteDate: "",
    Type: "",
    PlanTypeName: "",
    CampaignName: "-",
    IdTypeName: "",
    Name: "",
    SecondName: "",
    FirstLastName: "",
    SecondLastName: "",
    MarriedSurName: "-",
    Gender: "",
    Birthday: "",
    Address1: "-",
    Address2: "-",
    CountryName: "",
    ProvinceName: "",
    TownName: "",
    SectorName: "",
    PostalCode: "",
    PhoneOffice: "",
    PhoneHome: "-",
    PhoneNumber: "-",
    Email: "",
};
